import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { SharedModule } from './shared.module';
import { reducer } from './state/reducer';
import { DealEffects } from './state/deal/effects';
import { SharedComponent } from './shared.component';
import { AssignmentsEffects } from './state/assignments/effects';
import { AssignmentGroupsEffects } from './state/assignment-groups/effects';
import { BidsEffects } from './state/bids/effects';
import { CalendarEffects } from './state/calendar/effects';
import { PendoEffects } from './state/pendo/effects';
import { BenchmarkCurvesEffects } from './state/benchmark-curves/effects';
import { MonitorEffects } from './state/monitor/effects';
import { FollowsEffects } from './state/follows/effects';
import { WiresEffects } from './state/wires/effects';
import { UsersEffects } from './state/users/effects';
import { OrdersEffects } from './state/orders/effects';
import { SessionEffects } from './state/session/effects';
import { UserPermissionsEffects } from './state/user-permissions/effects';
import { UserPreferencesEffects } from './state/user-preferences/effects';
import { CalendarLivePollingEffect } from './state/calendar/live/effects';
import { MonitorLivePollingEffect } from './state/monitor/live/effects';
import { CasaSettingsEffects } from './state/casa-settings/effects';
import { DealMetricsEffects } from './state/deal-metrics/effects';
import { BidResultsEffects } from './state/bid-results/effects';
import { USTreasuriesEffects } from './state/treasuries/effects';
import { AnalyticsEffects } from './state/analytics/effects';
import { ManagerEffects } from './state/manager/effects';
import { ManagerLivePollingEffect } from './state/manager/live/effects';
import { CalendarFilterEffects } from './state/calendar-filter/effects';
import { ManagerFilterEffects } from './state/manager-filters/effects';
import { DealCardsBidResultsEffects } from './state/deal-cards-bid-results/effects';
import { DesignationsEffects } from './state/designations/effects';

export const routeModule = RouterModule.forChild([
  {
    path: '',
    component: SharedComponent
  }
]);
export const storeModule = StoreModule.forFeature('muni-shared', reducer);
export const effectModule = EffectsModule.forFeature([
  AnalyticsEffects,
  AssignmentGroupsEffects,
  AssignmentsEffects,
  DealMetricsEffects,
  BenchmarkCurvesEffects,
  BidsEffects,
  CalendarEffects,
  CalendarFilterEffects,
  CalendarLivePollingEffect,
  CasaSettingsEffects,
  DealEffects,
  FollowsEffects,
  MonitorEffects,
  ManagerEffects,
  ManagerFilterEffects,
  MonitorLivePollingEffect,
  ManagerLivePollingEffect,
  OrdersEffects,
  PendoEffects,
  SessionEffects,
  UserPermissionsEffects,
  UserPreferencesEffects,
  UsersEffects,
  WiresEffects,
  BidResultsEffects,
  DealCardsBidResultsEffects,
  USTreasuriesEffects,
  DesignationsEffects
]);

@NgModule({
  imports: [SharedModule, routeModule, effectModule, storeModule],
  declarations: [SharedComponent]
})
export class SharedRoutedModule { }
